import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

type ChangePasswordForm = {
  oldPassword: string;
  newPassword: string;
};

export const changePassword = ({
  oldPassword,
  newPassword,
}: ChangePasswordForm) => {
  return axios.post('/api/auth/change-password', { oldPassword, newPassword });
};

export const useChangePasswordMutation = () => {
  return useMutation({
    mutationFn: ({ oldPassword, newPassword }: ChangePasswordForm) =>
      changePassword({ oldPassword, newPassword }),
  });
};
